<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/doctors'"
  [currentPageValue]="editMode ? 'Edit Doctor' : 'Add Doctor'"
></page-header-breadcrumb>

  <div class="card mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-name">
              Doctor Name
            </label>

            <input
              class="form-control"
              id="doctor-name"
              [(ngModel)]="doctor && doctor.fullName"
              placeholder="Doctor Name"
              type="text"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-ar-name">
              Doctor Arabic Name
            </label>

            <input
              class="form-control"
              id="doctor-ar-name"
              [(ngModel)]="doctor && doctor.arFullName"
              placeholder="Doctor Arabic Name"
              type="text"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-email">
              Doctor Email
            </label>

            <input
              class="form-control"
              id="doctor-email"
              [(ngModel)]="doctor && doctor.email"
              placeholder="Doctor Email"
              type="email"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-password">
              Doctor Password
            </label>

            <input
              class="form-control"
              id="doctor-password"
              [(ngModel)]="doctor && doctor.password"
              placeholder="Doctor Password"
              type="password"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-title">
              Doctor Title
            </label>

            <select
              [(ngModel)]="doctor && doctor.titleId"
              class="form-control"
              id="doctor-title"
            >
              <option
                *ngFor="let item of doctorTitles; let i = index"
                [value]="item.id"
              >
                {{ item.enTitle }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-desc">
              Doctor Description
            </label>

            <input
              class="form-control"
              id="doctor-desc"
              [(ngModel)]="doctor && doctor.description"
              placeholder="Doctor Description"
              type="text"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctor-ar-desc">
              Doctor Arabic Description
            </label>

            <input
              class="form-control"
              id="doctor-ar-desc"
              [(ngModel)]="doctor && doctor.arDescription"
              placeholder="Doctor Arabic Description"
              type="text"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="gender"> Gender </label>

            <select
              [(ngModel)]="doctor && doctor.gender"
              class="form-control"
              id="gender"
            >
              <option *ngFor="let gender of genderList" [value]="gender.gen">
                {{ gender.gen }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-control-label" for="exampleDatepicker">
                    Birth Date
                  </label>
                  <input
                    type="text"
                    placeholder="Datepicker"
                    class="form-control"
                    bsDatepicker
                    [bsValue]="doctor && doctor.birthDate"
                    [bsConfig]="{
                      isAnimated: true,
                      containerClass: 'theme-blue'
                    }"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="phone"> Doctor Phone </label>

            <input
              class="form-control"
              id="phone"
              [(ngModel)]="doctor && doctor.phone"
              placeholder="Phone"
              type="tel"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="specialtyName">
              Doctor Specialty
            </label>

            <select
              [(ngModel)]="doctor && doctor.specialtyId"
              class="form-control"
              id="specialtyName"
            >
              <option *ngFor="let item of specialtiesArray" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="medicalId">
              Doctor Medical ID
            </label>

            <input
              class="form-control"
              id="medicalId"
              [(ngModel)]="doctor && doctor.medicalId"
              placeholder="Doctor Medical ID"
              type="number"
              min="0"
            />
          </div>
        </div>
        <!-- <div class=" col-md-6">
          <div class=" form-group">
            <label class=" form-control-label" for="medicalPathId">
              Doctor Medical Path ID
            </label>

            <input class=" form-control" id="medicalPathId" [(ngModel)]="doctor&& doctor.medicalIdPath"
              placeholder="Doctor Medical Path ID" type="number" min="0" />
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="doctorGet">
              Patient Pay
            </label>

            <input
              class="form-control"
              id="doctorGet"
              [(ngModel)]="doctor && doctor.doctorGet"
              placeholder="Patient Pay"
              type="number"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="counsultancyPatientPay">
              Consultancy Patient Pay
            </label>

            <input
              class="form-control"
              id="counsultancyPatientPay"
              [(ngModel)]="doctor && doctor.consultancyDoctorGet"
              placeholder="Consultancy Patient Pay"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="slotTime"> Slot Time </label>

            <input
              class="form-control"
              id="slotTime"
              [(ngModel)]="doctor && doctor.slotTime"
              placeholder="Slot Time"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="city-id">
              Choose city
            </label>

            <select
              [(ngModel)]="doctor && doctor.cityId"
              class="form-control"
              id="city-id"
            >
              <option *ngFor="let city of cities" [value]="city.id">
                {{ city.enName }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="packageLimitNumber">
              Package Limit Number
            </label>

            <input
              class="form-control"
              id="packageLimitNumber"
              [(ngModel)]="doctor && doctor.packageLimitNumber"
              placeholder="Package Limit Number"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="packagePeriodInDay">
              Package period in days
            </label>

            <input
              class="form-control"
              id="packagePeriodInDay"
              [(ngModel)]="doctor && doctor.packagePeriodInDays"
              placeholder="Package period in days"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="packageDoctorGet">
              Package Doctor get
            </label>

            <input
              class="form-control"
              id="packageDoctorGet"
              [(ngModel)]="doctor && doctor.packageDoctorGet"
              placeholder="Package Doctor get"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="packagePatientPay">
              Package Patient Pay
            </label>

            <input
              class="form-control"
              id="packagePatientPay"
              [(ngModel)]="doctor && doctor.packagePatientPay"
              placeholder="Package Patient Pay"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="userName"> User Name </label>

            <input
              class="form-control"
              id="userName"
              [(ngModel)]="doctor && doctor.userName"
              placeholder="User Name"
              type="text"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="ssn"> ID Number </label>

            <input
              class="form-control"
              id="ssn"
              [(ngModel)]="doctor && doctor.ssn"
              placeholder="SSN"
              type="number"
              min="0"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="rankFormControl">
              Rank
            </label>

            <select
              [(ngModel)]="doctor.rank"
              class="form-control"
              id="rankFormControl"
            >
              <option *ngFor="let item of ranks; let i = index" [value]="i + 1">
                {{ i + 1 }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="topDoctorRank">
              Top Doctor Rank
            </label>

            <select
              [(ngModel)]="doctor && doctor.topDoctorRank"
              class="form-control"
              id="topDoctorRank"
            >
              <option *ngFor="let item of ranks; let i = index" [value]="i + 1">
                {{ i + 1 }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="type"> Type ID </label>
            <select
              [(ngModel)]="doctor && doctor.typeId"
              class="form-control"
              id="type"
            >
              <option
                *ngFor="let item of doctorTypes; let i = index"
                [value]="item.id"
              >
                {{ item.type }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="consultancyDaysWithin">
              Consultancy Days Within
            </label>
            <input
              class="form-control"
              id="consultancyDaysWithin"
              [(ngModel)]="doctor && doctor.consultancyDaysWithin"
              placeholder="Consultancy Days Within"
              type="number"
              min="0"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="lang">
              First Language
            </label>
            <select
              [(ngModel)]="doctor && doctor.spokenLanguageIdsList[0]"
              class="form-control"
              id="lang"
            >
              <option
                *ngFor="let item of languages; let i = index"
                [value]="item.id"
              >
                {{ item.enName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label" for="lang2">
              Second Language
            </label>
            <select
              [(ngModel)]="doctor && doctor.spokenLanguageIdsList[1]"
              class="form-control"
              id="lang2"
            >
              <option
                *ngFor="let item of languages; let i = index"
                [value]="item.id"
              >
                {{ item.enName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <label class="mr-6 mb-0" for="anon-check">Accept Promo Codes?</label>
          <label class="custom-toggle custom-toggle-default">
            <input
              checked="checked"
              type="checkbox"
              id="anon-check"
              [(ngModel)]="doctor && doctor.acceptPromoCodes"
            />

            <span
              class="custom-toggle-slider rounded-circle"
              data-label-off="No"
              data-label-on="Yes"
            >
            </span>
          </label>
        </div>

        <!-- <div class=" col-md-6">
          <div class=" form-group">
            <label class=" form-control-label" for="offer-route">
              Choose the Route
            </label>

            <select [(ngModel)]="doctor && doctor.ro" class=" form-control" id="offer-route"
              (change)="routeChanged($event.target.value)">
              <option *ngFor="let route of routes" [value]="route.id"> {{route.pageName}} </option>
            </select>
          </div>
        </div> -->
        <!--
    <div class=" card-body">
      <form>
        <select class=" form-control" data-toggle="select" id="selectr">
          <option *ngFor="let route of routes" [value]="route"> {{route.name}} </option> </select>
      </form>
    </div> -->
      </div>

      <!-- <div class="row">
        <div class="col-md-6">
          <div class=" form-group">
            <label class="form-control-label">
              Creation Date
            </label>

            <input type="text" class="form-control" bsDaterangepicker [(ngModel)]="doctor.creationDate" [bsConfig]="{
            isAnimated: true,
            containerClass: 'theme-blue'
          }" name="bsDaterangepicker" />
          </div>
        </div>
        <div class=" col-md-6">
          <div class=" form-group">
            <label class=" form-control-label" for="rankFormControl">
              Rank
            </label>

            <select [(ngModel)]="doctor.rank" class=" form-control" id="rankFormControl">
              <option *ngFor="let item of ranks; let i = index" [value]="i+1"> {{i+1}} </option>
            </select>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col">
          <div class="form-group">
            <br />
            <form>
              <div class="custom-file">
                <input
                  (change)="onImageUpload($event)"
                  class="custom-file-input"
                  id="doctor-image"
                  lang="en"
                  type="file"
                  accept=".jpg,.png"
                />

                <label class="custom-file-label" for="doctor-image">
                  {{
                    (imageFile && imageFile.name) ||
                      doctor.imagePath ||
                      "Select file"
                  }}
                </label>
              </div>
            </form>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <br />
            <form>
              <div class="custom-file">
                <input
                  (change)="onMedicalIdUpload($event)"
                  class="custom-file-input"
                  id="doctor-medical-image"
                  lang="en"
                  type="file"
                  accept=".jpg,.png"
                />

                <label class="custom-file-label" for="doctor-medical-image">
                  {{
                    (medicalId && medicalId.name) ||
                      doctor.medicalIdImage ||
                      "Select file"
                  }}
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col btns-block">
          <button
            class="btn btn-primary"
            type="button"
            (click)="onAddNewDoctor()"
          >
            {{ editMode ? "Edit" : "Save" }}
          </button>
          <button
            class="btn btn-outline-danger"
            type="button"
            [routerLink]="'/offers'"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
